module.exports = __webpack_public_path__ + "img/Streamingkarte_Mockup.5a2e3b4b.png";